export default "__VITE_ASSET__CON2MUf0__"